module.exports = __webpack_public_path__ + "img/book-page-bg.19f7716f.webp";